import React from "react";
import ReactDOM from 'react-dom';
import { useState } from 'react';

const LocationWidget = window.auiEmbeddableWidgets.reactComponent(
  // url to the definition
  'https://locationwidgets.antwerpen.be/definitions/location-viewer.json',
  { React, ReactDOM }
)
const MapWrapper = (props) => {
  const [setPosition, setSetPosition] = useState(() => {})

  let location = props.location || false;
  let markers = props.markers || [{}];
  if(props.markers && props.markers.length === 0) {
    // set muti empty to force map to update
    markers = [{}, {}];
  }
  const operaticlassonalLayerOptions = {
    name: 'Taken',
    isVisible: true,
    markers,
    enableClustering: true,
  };

  let layerIds = !!props.layers && props.layers.map(({ layerId }) => layerId);
  layerIds = layerIds && layerIds.filter((id, index) => layerIds.indexOf(id) === index);

  const supportingLayerOptions = {
    url: 'https://geodata.antwerpen.be/arcgissql/rest/services/P_ATODO/ATODO/MapServer',
    layerIds,
  };
  return <>
    <LocationWidget
      onFilteredResult={props.onFilteredResult}
      operationalLayerOptions={operaticlassonalLayerOptions}
      supportingLayerOptions={supportingLayerOptions}
      showLayerManagement={true}
      showSelectionTools={false}
      showWhatIsHereButton={true}
      showLocateButton={true}
      showMeasureTools={false}
      enableClustering={true}
      currentPosition={location}
      onLocateButtonClick={(x, y) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setPosition([latitude, longitude])
          },
          (error) => {
              console.error('Error getting user location:', error);
          }
        );
      }}
      onRegisterSetCurrentPosition={(setPos) => {
        if(location && location[0]) {
          setSetPosition(() => setPos);
          setPos(location);
        }
      }}
      onWhatIsHereSelected={props.onWhatIsHereSelected}
      zoomOnMarkerSelect={18}
      className={`map-widget ${props.className}`}
      branding="antwerp"
    />
  </>;
}

export default MapWrapper;
